import { BASE_URL, HTTP_METHODS } from "../App/Configs/AppConfigs";
import ApiHelper from "../App/Utils/ApiHelper";
import { DPR_BASE_API_PATH } from "./Constants";

export class DataProvider {
  apiHelper = new ApiHelper(BASE_URL + DPR_BASE_API_PATH);
  masterApiHelper = new ApiHelper(BASE_URL + "/master-data");

  getProgressList = async (values) => {
    return await this.apiHelper.apiCall('/list' + values, HTTP_METHODS.GET, null);
  }; 

  getProgressData = async (id) => {
    return await this.apiHelper.apiCall('/list/' + id, HTTP_METHODS.GET, null);
  }; 

  submitProgress = async (values) => {
    return await this.apiHelper.apiCall('/', HTTP_METHODS.POST, values);
  }; 

  editProgress = async (values, id) => {
    return await this.apiHelper.apiCall('/list/' + id, HTTP_METHODS.PATCH, values);
  }; 

  getDropdownValues = async (model) => {
    return await this.masterApiHelper.apiCall('/masters.'+model+"/list?is_active=True&filter=1&page=1&pageSize=100000", HTTP_METHODS.GET, null);
  };

  getDependentDropdownValues = async (model, filter) => {
    return await this.masterApiHelper.apiCall('/masters.'+model+"/list?is_active=True&page=1&pageSize=100000&filter=1&"+filter, HTTP_METHODS.GET, null);
  };

  sumbitVendorInputs = async (values, requestID) => {
    return await this.apiHelper.apiCall('/update-vendor-inputs/' + requestID, HTTP_METHODS.PATCH, values);
  }

  fetchLinkDetails = async (token) => {
    return await this.apiHelper.apiCall('/get-token-details/' + token, HTTP_METHODS.GET, null);
  }

  importProgress = async (data) => {
    return await this.apiHelper.apiCall('/import', HTTP_METHODS.POST, data);
  }

  downloadImportTemplate = async () => {
    return await this.apiHelper.apiCall('/download-import-template', HTTP_METHODS.POST, null);
  }
}
